/**
 * TileSkeleton — loading placeholder for the catalogue-card-v2 `.dp-card`.
 * Mirrors the real card's DOM shape (icon-left head + footer) so it
 * occupies the same ≈134px as a loaded card — no layout shift on load.
 */
export default function TileSkeleton() {
  return (
    <article className="dp-card" aria-hidden="true">
      <style>{`
        @keyframes dp-skeleton-pulse {
          from { opacity: 0.55; }
          to   { opacity: 0.85; }
        }
      `}</style>
      <div className="dp-card__head">
        <div
          className="dp-card__mark"
          style={{ background: 'var(--dp-canvas-200)', animation: 'dp-skeleton-pulse 1400ms var(--ease-out) infinite alternate' }}
        />
        <div className="dp-card__text" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-1)' }}>
          <div
            style={{
              height: '15px',
              width: '55%',
              background: 'var(--dp-canvas-200)',
              borderRadius: 'var(--radius-sm)',
              animation: 'dp-skeleton-pulse 1400ms var(--ease-out) infinite alternate',
            }}
          />
          <div
            style={{
              height: 'calc(2 * 1.45 * var(--fs-body-sm))',
              width: '100%',
              background: 'var(--dp-canvas-200)',
              borderRadius: 'var(--radius-sm)',
              animation: 'dp-skeleton-pulse 1400ms var(--ease-out) infinite alternate',
            }}
          />
        </div>
      </div>
      <div className="dp-card__foot">
        <div
          style={{
            height: '16px',
            width: '104px',
            background: 'var(--dp-canvas-200)',
            borderRadius: 'var(--radius-sm)',
            animation: 'dp-skeleton-pulse 1400ms var(--ease-out) infinite alternate',
          }}
        />
      </div>
    </article>
  );
}
